import i from './profile.container';

export default i;
